






















































































































































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import PrefillReviewList, {
  PrefillReviewItem
} from "@/components/prefill/PrefillReviewList.vue";
import FormPrefillService from "@/services/FormPrefillService";
import AsesmenAwalRanapAnakSvc from "@/services/AsesmenAwalRanapAnak";
import AsesmenAwalRanapAnakStore from "@/store/modules/AsesmenAwalRanapAnakStore";
import { userModule } from "@/store/modules/user";
import { PPJA_ONLY_HINT } from "@/utility/AsuhanKeperawatanHelper";
import { appModule } from "@/store/modules/app";
import StrongKidsCard from "./anak/StrongKidsCard.vue";
import HumptyDumptyCard from "./anak/HumptyDumptyCard.vue";
import WongBakerFacesInput from "./anak/WongBakerFacesInput.vue";
import ImunisasiCheckboxGroup from "./anak/ImunisasiCheckboxGroup.vue";

@Component({
  components: {
    StrongKidsCard,
    HumptyDumptyCard,
    WongBakerFacesInput,
    ImunisasiCheckboxGroup,
    PrefillReviewList,
  },
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class AsesmenAwalAnakPage extends Mixins(PrefillMixin) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: false }) isActive!: boolean;
  @Prop({ default: null }) pasienData!: any;

  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "asesmen_awal_ranap_anak";

  /**
   * Path relatif this.form — hanya key yang sudah ada di getEmptyForm()
   * yang diisi (reaktif). Path *_list & tak dikenal di-skip.
   */
  prefillResolvePath(path: string) {
    if (path.indexOf("_list") !== -1) {
      return { get: () => "__skip__", set: () => undefined };
    }
    const segments = path.split(".");
    const last = segments.pop() as string;
    const parent = segments.reduce(
      (acc: any, seg) => (acc == null ? acc : acc[seg]),
      this.form
    );
    if (parent && Object.prototype.hasOwnProperty.call(parent, last)) {
      return {
        get: () => parent[last],
        set: (v) => {
          parent[last] = v;
        }
      };
    }
    return { get: () => "__skip__", set: () => undefined };
  }

  get prefillRpdList(): PrefillReviewItem[] {
    const p = this.prefillPayload;
    return p && p.fields ? p.fields["riwayat.rpd_list"] || [] : [];
  }

  applyRpdList(items: PrefillReviewItem[]) {
    const lines = items.map(it => it.value).filter(Boolean);
    if (lines.length === 0) return;
    const existing = (this.form.riwayat_kesehatan.riwayat_kesehatan_lalu || "").trim();
    this.form.riwayat_kesehatan.riwayat_kesehatan_lalu = existing
      ? existing + "\n" + lines.join("\n")
      : lines.join("\n");
    FormPrefillService.logAcceptance({
      form_key: this.prefillFormKey,
      pasien_rm: String(this.rm),
      register_id: this.register,
      unit_id: this.stateuser ? this.stateuser.unit_id : null,
      event: "partial",
      fields: ["riwayat.rpd_list"],
      provenance: {},
      sources: this.prefillPayload ? this.prefillPayload.sources : []
    });
  }
  // ───────────────────────────────────────────────────────────────────

  loading = false;
  saving = false;
  isEditing = false;
  formValid = false;
  verifyingPpja = false;
  verifyingDpjp = false;

  viewPanels: number[] = [];
  formPanels: number[] = Array.from({ length: 7 }, (_, i) => i);

  pancaIndraFields = [
    { key: "penglihatan", label: "Penglihatan" },
    { key: "pendengaran", label: "Pendengaran" },
    { key: "penciuman", label: "Penciuman" },
    { key: "mulut", label: "Mulut" },
  ];

  statusMobilisasiFields = [
    { key: "duduk", label: "Duduk" },
    { key: "berdiri", label: "Berdiri" },
    { key: "jalan", label: "Jalan" },
  ];

  adlKatzFields = [
    { key: "mandi", label: "Mandi" },
    { key: "berpakaian", label: "Berpakaian" },
    { key: "berhias", label: "Berhias dan Berpakaian" },
    { key: "berpindah", label: "Berpindah" },
    { key: "toileting", label: "Toileting" },
    { key: "makan", label: "Makan" },
  ];

  mobilisasiBantuanOptions = [
    { label: "Mandiri", value: "mandiri" },
    { label: "Dengan bantuan orang", value: "bantuan_orang" },
    { label: "Dengan bantuan alat", value: "bantuan_alat" },
    { label: "Dengan bantuan orang dan alat", value: "bantuan_orang_dan_alat" },
  ];

  form: any = this.getEmptyForm();

  mounted() {
    this.loadData();
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.record) {
      this.loadData();
    }
  }

  // ========== Computed ==========

  get record() {
    return AsesmenAwalRanapAnakStore.asesmen;
  }

  get viewContent() {
    return (this.record && this.record.content) || {};
  }

  get stateuser() {
    return userModule.user;
  }

  get perawatNama(): string {
    if (this.record && this.record.perawat && this.record.perawat.nama) {
      return this.record.perawat.nama;
    }
    if (this.record) return "-";
    return (this.stateuser && this.stateuser.nama) || "-";
  }

  get isPengkajiAwal(): boolean {
    if (!this.record) return true;
    return Number(this.record.perawat_user_id) === Number(this.stateuser.id);
  }

  get perawatPengkajiHint(): string {
    if (!this.record) return "Diisi otomatis dari akun yang login";
    if (this.isPengkajiAwal) return "Perawat yang pertama mengkaji pasien ini";
    return `Anda melengkapi asesmen yang dikaji ${this.perawatNama} — nama pengkaji awal tidak berubah`;
  }

  get canEdit() {
    if (!this.record) return false;
    if (this.record.dpjp_verified_at) return false;
    return userModule.canAccessForm("asesmen_awal_ranap_anak", "edit");
  }

  get canDelete() {
    if (!this.record) return false;
    if (this.record.dpjp_verified_at) return false;
    return userModule.canAccessForm("asesmen_awal_ranap_anak", "edit");
  }

  get canCreate(): boolean {
    return userModule.canAccessForm("asesmen_awal_ranap_anak", "create");
  }

  get canUpdateSigned(): boolean {
    return userModule.hasPrivilege("asesmen_awal_ranap_anak", "update_signed");
  }

  get ppjaVerified(): boolean {
    return !!(this.record && this.record.ppja_verified_at);
  }

  get dpjpVerified(): boolean {
    return !!(this.record && this.record.dpjp_verified_at);
  }

  get canVerifyAsesmenKeperawatan(): boolean {
    return userModule.canVerifyAsesmenKeperawatan;
  }

  get ppjaOnlyHint(): string {
    return PPJA_ONLY_HINT;
  }


  get patientAgeMonths(): number {
    if (!this.pasienData || !this.pasienData.tgl_lahir) return 48;
    const birth = new Date(this.pasienData.tgl_lahir);
    const now = new Date();
    return (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
  }

  get gcsTotal(): number {
    return (this.form.keadaan_umum.gcs.e || 0) + (this.form.keadaan_umum.gcs.v || 0) + (this.form.keadaan_umum.gcs.m || 0);
  }

  get nyeriKategori(): string {
    const v = this.form.asesmen_nyeri.skala_nyeri_value || 0;
    if (v === 0) return "tidak_nyeri";
    if (v <= 3) return "ringan";
    if (v <= 6) return "sedang";
    return "berat";
  }

  get indeksKatz(): string {
    const m = this.form.status_fisik.muskuloskeletal.status_mobilisasi;
    const dibantu = ["mandi", "berpakaian", "berhias", "makan", "toileting", "berpindah"]
      .filter((k) => m[k] === "dibantu").length;
    return ["A", "B", "C", "D", "E", "F", "G"][dibantu] || "G";
  }

  get effectiveJk(): string {
    const jk = this.pasienData && this.pasienData.jk;
    if (jk === "P" || jk === "L") return jk;
    return this.form.status_fisik.urinaria_reproduksi.jk_manual || "";
  }

  mobLabel(value: string): string {
    const opt = this.mobilisasiBantuanOptions.find((o) => o.value === value);
    return opt ? opt.label : "-";
  }

  katzKategori(letter: string): string {
    const map: Record<string, string> = {
      A: "Semua mandiri",
      B: "1 dari 6 dibantu",
      C: "2 dari 6 dibantu",
      D: "3 dari 6 dibantu",
      E: "4 dari 6 dibantu",
      F: "5 dari 6 dibantu",
      G: "Semua dibantu",
    };
    return map[letter] || "";
  }

  get perluPerencanaanLanjutan(): boolean {
    const p = this.form.perencanaan_pulang;
    return p.tidak_tinggal_bersama_ortu || p.perlu_rujukan_komunitas || p.peralatan_medis_pulang
      || p.alat_bantu_pulang || p.edukasi_keterampilan_khusus
      || p.perawatan_lanjutan || p.diet_khusus;
  }

  // ========== Helpers ==========

  g(path: string, def: any = null): any {
    const keys = path.split(".");
    let obj: any = this.viewContent;
    for (const k of keys) {
      if (obj == null) return def;
      obj = obj[k];
    }
    return obj != null ? obj : def;
  }

  // ========== Data ==========

  async loadData() {
    this.loading = true;
    try {
      await AsesmenAwalRanapAnakStore.getByRegister(this.register);
    } finally {
      this.loading = false;
    }
    // Record baru: soft-prefill hanya field kosong (TTV/BB-TB baseline +
    // saran RPD). Tidak pernah pada record tersimpan / mode edit.
    if (!this.record && !this.isEditing && this.canCreate) {
      this.$nextTick(() => {
        this.loadPrefill({
          pasien_rm: String(this.rm),
          register_id: this.register,
          unit_id: this.stateuser ? this.stateuser.unit_id : undefined
        });
      });
    }
  }

  getEmptyForm() {
    const now = new Date();
    return {
      info_asesmen: {
        tanggal: localISODate(now),
        pukul: now.toTimeString().substr(0, 5),
        cara_tiba: "jalan",
        cara_tiba_lainnya: "",
      },
      riwayat_kesehatan: {
        keluhan_utama: "",
        riwayat_kesehatan_sekarang: "",
        riwayat_kesehatan_lalu: "",
        riwayat_pengobatan: "",
        riwayat_kesehatan_keluarga: "",
        alergi: { ada: false, reaksi: "" },
        transfusi_darah: { pernah: false, reaksi_alergi: false, reaksi_keterangan: "" },
        imunisasi: {
          bcg: false, hb0: false, hb1: false, hb2: false, hb3: false,
          polio1: false, polio3: false, dpt1: false, dpt2: false, dpt3: false,
          campak: false, boster: false, lainnya: "",
        },
        tumbuh_kembang: { normal: true, gangguan: "" },
      },
      keadaan_umum: {
        kesadaran: "cm",
        gcs: { e: 4, v: 5, m: 6, total: 15 },
        pupil: "isokor",
        vital_sign: {
          tekanan_darah_sistolik: null, tekanan_darah_diastolik: null,
          nadi: null, rr: null, suhu: null, berat_badan: null, tinggi_badan: null,
        },
      },
      asesmen_nyeri: {
        skala_nyeri_type: "wong_baker",
        skala_nyeri_value: 0,
        kategori_nyeri: "tidak_nyeri",
        nyeri_mempengaruhi: {
          tidur: false, aktivitas_fisik: false, emosi: false,
          nafsu_makan: false, konsentrasi: false, lainnya: "",
        },
        detail_nyeri: {
          lokasi: "", intensitas: 0, lama_nyeri: "", pencetus: "",
          kualitas_nyeri: "", pola_serangan: "", yang_menghilangkan: "",
        },
      },
      status_fisik: {
        jantung_pernapasan: {
          nadi: "reguler", intensitas_nadi: "kuat", akral: "hangat", capillary_refill: "kurang_3_detik",
          pernapasan: ["normal"],
          suara_napas_tambahan: { ada: false, keterangan: "" },
          alat_bantu_nafas: { digunakan: false, jenis: [], lainnya: "" },
        },
        neurologi: {
          kejang: { ada: false, pukul: "", lama_menit: null },
          kaku_kuduk: false,
          lainnya: "",
        },
        panca_indra: {
          penglihatan: { normal: true, keterangan: "" },
          pendengaran: { normal: true, keterangan: "" },
          penciuman: { normal: true, keterangan: "" },
          mulut: { normal: true, keterangan: "" },
        },
        integument: { warna_kulit: "", akral: "", turgor_kulit: "", vulnus_luka: "" },
        gastrointestinal: {
          reflek_hisap_menelan: "kuat", nafsu_makan: "", diet_khusus: "",
          nutrisi_pengganti: { ada: false, ngt_no: "", ngt_dipasang_sejak: "", ngt_kecepatan: "" },
          perut: ["normal"], perut_nyeri_tekan: "",
          bab: { status: "normal", konstipasi_hari: null, diare_frekuensi: null, diare_konsistensi: "", diare_warna: "" },
        },
        urinaria_reproduksi: {
          bak: { status: "normal", frekuensi: "", bak_terakhir: "", warna: "", keluhan: "" },
          kelainan: [], kelainan_lainnya: "",
          kateter: { terpasang: false, sejak: "" },
          muntah: { status: "tidak", jenis: "", frekuensi: null, keterangan: "" },
          jk_manual: "",
          reproduksi_perempuan: { menstruasi: false, menarche_umur: null, lama_hari: null, keluhan: "" },
          reproduksi_laki: { normal: true, keterangan: "" },
        },
        muskuloskeletal: {
          rentang_gerak: "penuh",
          gangguan: { ada: false, keterangan: "" },
          fraktur: "",
          kekuatan_otot: {
            ekstremitas_atas_kiri: 5, ekstremitas_atas_kanan: 5,
            ekstremitas_bawah_kiri: 5, ekstremitas_bawah_kanan: 5,
          },
          status_mobilisasi: {
            mandi: "mandiri", berpakaian: "mandiri", berhias: "mandiri", makan: "mandiri",
            toileting: "mandiri", berpindah: "mandiri", duduk: "mandiri", berdiri: "mandiri", jalan: "mandiri",
          },
          indeks_katz: "A",
        },
        psikososial: {
          perilaku: { normal: true, keterangan: "" },
          koping: "adekuat",
          kemampuan_ungkap_masalah: { mampu: true, keterangan: "" },
          orang_terdekat: { nama: "", hubungan: "", no_telpon: "" },
          kebiasaan_beribadah: "mandiri",
          keyakinan_penyakit: "bisa_sembuh",
          ekonomi: "2jt_5jt",
        },
        skrining_nutrisi: {
          tampak_kurus: false, penurunan_bb: false, diare_muntah_asupan_kurang: false,
          penyakit_risiko_malnutrisi: false, skor_total: 0, kategori: "rendah",
        },
      },
      risiko_jatuh: {
        umur: 1, jenis_kelamin: 1, diagnosis: 1, gangguan_kognitif: 1,
        faktor_lingkungan: 1, respons_operasi: 1, penggunaan_obat: 1,
        skor_total: 7, kategori: "rendah",
        intervensi: {
          bel_mudah_dijangkau: false, roda_terkunci: false, posisi_terendah: false,
          pagar_dinaikkan: false, reasesmen_1x24jam: false, tanda_risiko_jatuh: false,
          edukasi_keluarga: false, intervensi_a_lainnya: "",
          dekat_nurse_station: false, reasesmen_2x_per_shift: false, intervensi_b_lainnya: "",
        },
      },
      kebutuhan_edukasi: { pertanyaan_orangtua: "", kebutuhan_informasi: "" },
      perencanaan_pulang: {
        tidak_tinggal_bersama_ortu: false, perlu_rujukan_komunitas: false,
        peralatan_medis_pulang: false, alat_bantu_pulang: false,
        edukasi_keterampilan_khusus: false, perawatan_lanjutan: false, diet_khusus: false,
        perlu_perencanaan_lanjutan: false,
      },
      masalah_keperawatan: [""],
    };
  }

  // ========== Actions ==========

  startEdit() {
    const c = JSON.parse(JSON.stringify(this.record.content));
    this.form = { ...c };
    // Ensure nested structures exist
    const empty = this.getEmptyForm();
    if (!this.form.status_fisik) this.form.status_fisik = empty.status_fisik;
    if (!this.form.status_fisik.jantung_pernapasan) this.form.status_fisik.jantung_pernapasan = empty.status_fisik.jantung_pernapasan;
    if (!this.form.status_fisik.neurologi) this.form.status_fisik.neurologi = empty.status_fisik.neurologi;
    if (!this.form.status_fisik.panca_indra) this.form.status_fisik.panca_indra = empty.status_fisik.panca_indra;
    if (!this.form.status_fisik.integument) this.form.status_fisik.integument = empty.status_fisik.integument;
    if (!this.form.status_fisik.gastrointestinal) this.form.status_fisik.gastrointestinal = empty.status_fisik.gastrointestinal;
    if (!this.form.status_fisik.urinaria_reproduksi) this.form.status_fisik.urinaria_reproduksi = empty.status_fisik.urinaria_reproduksi;
    if (!this.form.status_fisik.muskuloskeletal) this.form.status_fisik.muskuloskeletal = empty.status_fisik.muskuloskeletal;
    if (!this.form.status_fisik.muskuloskeletal.status_mobilisasi) this.form.status_fisik.muskuloskeletal.status_mobilisasi = empty.status_fisik.muskuloskeletal.status_mobilisasi;
    if (!this.form.status_fisik.psikososial) this.form.status_fisik.psikososial = empty.status_fisik.psikososial;
    if (!this.form.status_fisik.skrining_nutrisi) this.form.status_fisik.skrining_nutrisi = empty.status_fisik.skrining_nutrisi;
    if (!this.form.keadaan_umum) this.form.keadaan_umum = empty.keadaan_umum;
    if (!this.form.keadaan_umum.gcs) this.form.keadaan_umum.gcs = empty.keadaan_umum.gcs;
    if (!this.form.asesmen_nyeri) this.form.asesmen_nyeri = empty.asesmen_nyeri;
    if (!this.form.asesmen_nyeri.nyeri_mempengaruhi) this.form.asesmen_nyeri.nyeri_mempengaruhi = empty.asesmen_nyeri.nyeri_mempengaruhi;
    if (!this.form.asesmen_nyeri.detail_nyeri) this.form.asesmen_nyeri.detail_nyeri = empty.asesmen_nyeri.detail_nyeri;
    if (!this.form.risiko_jatuh) this.form.risiko_jatuh = empty.risiko_jatuh;
    if (!this.form.risiko_jatuh.intervensi) this.form.risiko_jatuh.intervensi = empty.risiko_jatuh.intervensi;
    if (!this.form.riwayat_kesehatan) this.form.riwayat_kesehatan = empty.riwayat_kesehatan;
    if (!this.form.riwayat_kesehatan.imunisasi) this.form.riwayat_kesehatan.imunisasi = empty.riwayat_kesehatan.imunisasi;
    if (!this.form.riwayat_kesehatan.alergi) this.form.riwayat_kesehatan.alergi = empty.riwayat_kesehatan.alergi;
    if (!this.form.riwayat_kesehatan.transfusi_darah) this.form.riwayat_kesehatan.transfusi_darah = empty.riwayat_kesehatan.transfusi_darah;
    if (!this.form.riwayat_kesehatan.tumbuh_kembang) this.form.riwayat_kesehatan.tumbuh_kembang = empty.riwayat_kesehatan.tumbuh_kembang;
    if (!this.form.info_asesmen) this.form.info_asesmen = empty.info_asesmen;
    if (!this.form.kebutuhan_edukasi) this.form.kebutuhan_edukasi = empty.kebutuhan_edukasi;
    if (!this.form.perencanaan_pulang) this.form.perencanaan_pulang = empty.perencanaan_pulang;
    if (!Array.isArray(this.form.masalah_keperawatan) || !this.form.masalah_keperawatan.length) {
      this.form.masalah_keperawatan = [""];
    }
    this.isEditing = true;
  }

  cancelForm() {
    this.isEditing = false;
  }

  buildPayload() {
    const contentFields = { ...this.form };

    // Auto-compute derived fields
    contentFields.keadaan_umum.gcs.total = this.gcsTotal;
    contentFields.asesmen_nyeri.kategori_nyeri = this.nyeriKategori;
    contentFields.status_fisik.muskuloskeletal.indeks_katz = this.indeksKatz;
    contentFields.perencanaan_pulang.perlu_perencanaan_lanjutan = this.perluPerencanaanLanjutan;

    // Determine pain instrument type from age
    if (this.patientAgeMonths < 2) {
      contentFields.asesmen_nyeri.skala_nyeri_type = "nips";
    } else if (this.patientAgeMonths <= 84) {
      contentFields.asesmen_nyeri.skala_nyeri_type = "flacc";
    } else {
      contentFields.asesmen_nyeri.skala_nyeri_type = "wong_baker";
    }

    return {
      register_id: parseInt(this.register),
      pasien_rm: this.rm,
      unit_id: (this.stateuser && this.stateuser.unit_id) || "",
      content: contentFields,
      examined_at: `${contentFields.info_asesmen.tanggal} ${contentFields.info_asesmen.pukul}:00`,
      perawat_user_id: this.stateuser && this.stateuser.id,
    };
  }

  async simpan() {
    if (this.readOnly) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;

      if (this.isEditing && this.record) {
        resp = await AsesmenAwalRanapAnakSvc.update(this.record.id, payload);
      } else {
        resp = await AsesmenAwalRanapAnakSvc.create(payload);
      }

      if (String(resp.status) === "1") {
        appModule.NoticeDelay(this.isEditing ? "Asesmen berhasil diperbarui" : "Asesmen berhasil disimpan");
        this.isEditing = false;
        await this.loadData();
      }
    } finally {
      this.saving = false;
    }
  }

  async verifyPpja() {
    if (!this.record || !this.stateuser || this.verifikasiTerkunci) return;
    this.verifyingPpja = true;
    try {
      await AsesmenAwalRanapAnakSvc.verifyPpja(this.record.id, {
        ppja_user_id: this.stateuser.id,
      });
      appModule.NoticeDelay("Asesmen telah diverifikasi oleh PPJA");
      await this.loadData();
    } finally {
      this.verifyingPpja = false;
    }
  }

  async verifyDpjp() {
    if (!this.record || !this.stateuser || this.verifikasiTerkunci) return;
    this.verifyingDpjp = true;
    try {
      await AsesmenAwalRanapAnakSvc.verifyDpjp(this.record.id, {
        dpjp_user_id: this.stateuser.id,
      });
      appModule.NoticeDelay("Asesmen telah diverifikasi oleh DPJP");
      await this.loadData();
    } finally {
      this.verifyingDpjp = false;
    }
  }

  cetakPdf() {
    if (this.record) {
      AsesmenAwalRanapAnakSvc.printPdf(this.record.id);
    }
  }

  async hapus() {
    if (this.readOnly) return;
    const q = confirm("Anda yakin akan menghapus Asesmen Awal Keperawatan Anak ini?");
    if (!q) return;

    try {
      const resp = await AsesmenAwalRanapAnakSvc.destroy(this.record.id);
      if (resp && resp.status == 1) {
        appModule.NoticeDelay("Berhasil menghapus data");
        await this.loadData();
      }
    } catch {
      // handled by service
    }
  }
}
